module.exports = __webpack_public_path__ + "static/media/cheese-close-up-diet-61180.ab8739f2.png";